import I18n from "i18n-js";
import translations from "./translations.json";
I18n.translations = translations;
export default I18n;
